class Header {
  constructor() {
    this.header = document.getElementById("main-header");
    this.contactSubMenu = document.getElementById("contact-sub-menu");
    this.serviceSubMenu = document.getElementById("services-sub-menu");
    this.moreSubMenu = document.getElementById("more-sub-menu");

    document.addEventListener("scroll", () => {
      if (window.scrollY >= 50 || window.pageXOffset >= 50) {
        this.header.classList.add("active");
      } else {
        this.header.classList.remove("active");
      }
    });

    this.contactSubMenu.addEventListener("click", (event) => {
      this.contactSubMenu.classList.toggle("active");
    });

    this.serviceSubMenu.addEventListener("click", (event) => {
      this.serviceSubMenu.classList.toggle("active");
    });

    // this.moreSubMenu.addEventListener("click", (event) => {
    //   this.moreSubMenu.classList.toggle("active");
    // });
  }
}

export default Header;
